import React from "react";
import { FormattedMessage } from "react-intl";

const CardTotalPerYear = ({ title, value1, value2, value3 }) => {
  return (
    <div className="roi--total-card">
      <p className="roi--total-subtitle">{title}</p>
      <div>
        <h2 className="roi--total-main-number">{value1}</h2>
        <p className="roi--total-description">
          <FormattedMessage id="appointmentsSaved" />
        </p>
      </div>
      <div className="roi--total-footer">
        <div className="roi--total-footer-block">
          <p className="roi--total-footer-text">
            <FormattedMessage id="upTo" />
          </p>
          <p className="roi--total-footer-number">{value2}</p>
          <p className="roi--total-footer-text">
            <FormattedMessage id="onBraces" values={{ br: <br /> }} />
          </p>
        </div>
        <div className="roi--total-footer-block">
          <p className="roi--total-footer-text">
            <FormattedMessage id="upTo" />
          </p>
          <p className="roi--total-footer-number">{value3}</p>
          <p className="roi--total-footer-text">
            <FormattedMessage id="onAligners" values={{ br: <br /> }} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardTotalPerYear;
